/*
    🔥 AUTH ACCESS
        Utilidad de acceso directo utilizada por el header para Login y Client Portal.
        El componente recibe path y label, por lo que no conoce qué tipo de acceso
        está representando y puede reutilizarse para ambas capacidades globales.

    ----------------------------------------------------------------------------
    🔥 COMPORTAMIENTO
        No utiliza dropdown porque representa una navegación directa.
        AppHeaderUtilities controla su visibilidad mediante hideWhenAuth para que
        estos accesos se oculten cuando existe una sesión iniciada.
*/

import { Link } from 'react-router-dom';
import { FaDoorOpen } from 'react-icons/fa';

const BLOCK = 'LStudio__app_utility';


export const AuthAccess = ({ path = '/login', label = '' }) => (

    <Link to={path} className={`${BLOCK}__portal`} title={label} aria-label={label}>

        <FaDoorOpen size={16} aria-hidden="true" />

        <span className={`${BLOCK}__portal_label`}>{label}</span>

    </Link>
);

